const ELIGIBILITY_CHECK_TOKEN_PRODUCTION = 'ybTljzoN7ENXlAxIG8WL3ZiopXbJq4DK';
const ELIGIBILITY_CHECK_TOKEN_STAGING = 'lIa6Ht9ev8IDYvWb1b1Jtd1VB1488K2W';

// process.env.DEFAULT_ELIGIBILITY_CHECK_TOKEN works in local and development.
// In staging and production, use the hard-coded tokens for now.
export function getEligibilityCheckToken() {
  const token = process.env.DEFAULT_ELIGIBILITY_CHECK_TOKEN;
  if (token) {
    return token;
  }
  return process.env.NODE_ENV === 'production' ? ELIGIBILITY_CHECK_TOKEN_PRODUCTION : ELIGIBILITY_CHECK_TOKEN_STAGING;
}
